import { useState, useContext, useEffect, useRef, useReducer } from "react";
import { Offcanvas, Row, Col } from "react-bootstrap";
import useFetchData from "../components/useFetchDatav2";
import { useToast } from "../Context/useToast.jsx";
import prettyBytes from "pretty-bytes";
import { DOCUMENT_TYPES } from "../constants/documentTypes.js";
import { DOCUMENT_STATUS } from "../constants/documentStatus.js";
import { format } from "date-fns";
import { useDateFormat } from "../Context/PreferencesContext";
import { FaCheckCircle, FaExclamationTriangle, FaMinusCircle, FaSpinner, FaExclamationCircle } from "react-icons/fa";

//use this for the modal dialgue its an object
const initialModalDialgueState = {
   isOpen: false,
   question: "",
};

// reducer function which takes 2 arguments
const reducer = (state, action) => {
   //switch is another way to perform if else if nothing matches it goes to default
   switch (action.type) {
      case "OPEN_MODAL":
         return { ...state, isOpen: true, question: action.payload.question };
      case "CLOSE_MODAL":
         return { ...state, isOpen: false };
      default:
         return state;
   }
};

const DocumentModal = ({ docId, eMode, docName, onCloseModal }) => {
   const fmtDate = useDateFormat();
   const getLabelById = (id, array) => {
      const item = array.find((elem) => elem.value == id);
      return item ? item.label : "";
   };

   // Status to icon and color mapping
   const statusIconMap = {
      SUCCESS: { icon: FaCheckCircle, color: "#28a745" },
      FAILED: { icon: FaExclamationTriangle, color: "#dc3545" },
      SKIPPED: { icon: FaMinusCircle, color: "#6c757d" },
      STARTED: { icon: FaSpinner, color: "#007bff" },
      NEEDS_REVIEW: { icon: FaExclamationCircle, color: "#ffc107" },
   };

   const getStatusIcon = (status) => {
      return statusIconMap[status] || { icon: FaExclamationCircle, color: "#6c757d" };
   };
   const [show, setShow] = useState(true);
   const [formIsDirty, setFormIsDirty] = useState(false);
   // We use this as a flag to determine if the offcanvas is in the procsess of closing due to user interaction (clickingclose button or backdrop)
   const isExitingRef = useRef(false);
   // We use useReducer because it can manage more complex state logic
   const [modalDialgueState, dispatchModal] = useReducer(reducer, initialModalDialgueState); // Start of Modal Dialogue state
   const { isOpen, question } = modalDialgueState; // Destructure modal state

   const [editMode, setEditMode] = useState(null);
   const [payloadDoc, setPayloadDoc] = useState(null);
   const [isLoadingDoc, setIsLoadingDoc] = useState(true);
   const { triggerToast } = useToast();
   const { fetchData } = useFetchData();

   //    useEffect(() => {
   //       if (eMode === "edit") {
   //          setShow(true);
   //       } else {
   //          setShow(false);
   //       }
   //    }, [eMode]);

   // Callback fired right before the offcanvas transitions out
   const handleExit = () => {
      console.log("Offcanvas has exited 1", isExitingRef.current);
   };
   // Callback fired as the offcanvas begins to transition out
   const handleExiting = () => {
      console.log("Offcanvas has exiting 2", isExitingRef.current);
   };
   // Callback fired after the offcanvas finishes transitioning out
   const handleExited = () => {
      console.log("Offcanvas has exited 3", isExitingRef.current);
   };
   //This function is called when the AppointmentForm component is closing
   const onClose = (e) => {
      isExitingRef.current = true;
      setShow(false);
      console.log("Offcanvas has onClose");
      onCloseModal?.();
   };

   //This function is called when the Offcanvas component has been hidden
   const onHandleHide = (e) => {
      if (formIsDirty) {
         // Open modal with appropriate question
         dispatchModal({ type: "OPEN_MODAL", payload: { question: "Are you sure you want to discard changes?" } });
      } else {
         dispatchModal({ type: "CLOSE_MODAL", payload: { question: "" } });
         //we are here which means the offcanvas is hidden so set the ref to true
         isExitingRef.current = true;
         setShow(false);
         console.log("Offcanvas has onClose");
         onCloseModal?.();
      }
   };

   // we listen for the modal dialgue response which is a callback from ModalDialgue
   const handleModalResponse = (response) => {
      if (response === "discard") {
         // Your logic for discarding changes
         isExitingRef.current = true;
         setShow(false);
         console.log("Offcanvas has onClose");
         onCloseModal?.();
      } else if (response === "go_back") {
         dispatchModal({ type: "CLOSE_MODAL", payload: { question: "" } });
      }
      dispatchModal({ type: "CLOSE_MODAL" }); // Close modal after handling response
   };
   // Fetch Document
   useEffect(() => {
      const getDocument = async () => {
         const url = "/getDoc.sz";
         const method = "POST";
         const formData = new FormData();
         if (docId) {
            formData.append("_doc_id", docId);
         }
         try {
            const { responseData, fetchLoading, fetchError } = await fetchData(url, method, formData, "form-data");
            console.log("RESPONSEDATA:", responseData);
            setIsLoadingDoc(false);
            if (responseData.st === 1) {
               if (responseData?.payload?.length > 0) {
                  setPayloadDoc(responseData?.payload[0]);
               }
            } else {
               if (responseData.m_en) {
                  setIsLoadingDoc(false);
                  triggerToast("warning", responseData.m_en, false, "", false);
               } else {
                  setIsLoadingDoc(false);
                  triggerToast("error", "We seem to have an issue retrieving document detail, please try again later.", true, "Issue", false, 0);
               }
            }
         } catch (error) {
            setIsLoadingDoc(false);
            triggerToast("error", "We seem to have an access your data, please try again later.", true, "Network Issue", false, 0);
         }
      };
      getDocument();
   }, [docId]);

   return (
      <>
         <Offcanvas show={show} onHide={onHandleHide} onExiting={handleExiting} onExit={handleExit} onExited={handleExited} placement="end" className="offcanvas-width-l">
            <Offcanvas.Header closeButton className="">
               <Row className="d-flex align-items-start">
                  <Col>
                     <p className="fs-5 mb-1">{payloadDoc?.document_steps?.document?.doc_name}</p>
                  </Col>
               </Row>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-3" style={{ maxHeight: "calc(100vh - 3.5rem)", overflowY: "auto" }}>
               <Row>
                  <Col md={12}>
                     <div className="card-bc border-0">
                        <div className="card-body border-top border-1" style={{ "--card-body-content": "'Document'" }}>
                           <Row className="mt-3">
                              <Col md={6}>
                                 <div className="d-flex flex-column flex-fill">
                                    <div className="fw-semibold text-nowrap">Document Type</div>
                                    <div>{getLabelById(payloadDoc?.document_steps?.document?.doc_type, DOCUMENT_TYPES)}</div>
                                    <div className="mt-4 fw-semibold text-nowrap">File Type</div>
                                    <div className="">{payloadDoc?.document_steps?.document?.file_type}</div>
                                 </div>
                              </Col>
                              <Col md={6}>
                                 <div className="d-flex flex-column flex-fill">
                                    <div className="fw-semibold text-nowrap">Size</div>
                                    <div>{payloadDoc?.document_steps?.document?.doc_size ? prettyBytes(payloadDoc?.document_steps?.document?.doc_size) : 0}</div>
                                    <div className="mt-4 fw-semibold text-nowrap ">Uploaded By</div>
                                    <div className="">{payloadDoc?.document_steps?.document?.doc_upload_by}</div>
                                 </div>
                              </Col>
                           </Row>
                        </div>
                     </div>
                  </Col>
               </Row>
               <Row>
                  <Col>
                     <div className="card-bc border-0">
                        <div className="card-body border-top border-1" style={{ "--card-body-content": "'Document Events'" }}>
                           <ul className="events-list mt-3">
                              {payloadDoc?.document_steps?.document_steps && payloadDoc.document_steps.document_steps.length > 0 ? (
                                 payloadDoc.document_steps.document_steps.map((docStep, index) => {
                                    const { icon: IconComponent, color } = getStatusIcon(docStep.status);
                                    return (
                                       <li key={index} className="">
                                          <div className="event-date">
                                             <h5>
                                                <IconComponent style={{ color }} />
                                             </h5>
                                          </div>
                                          <div className="events-body">
                                             <div className="ev-item">
                                                <small>{docStep.completed_at ? `${fmtDate(docStep.completed_at)} ${format(new Date(docStep.completed_at), "HH:mm a")}` : "Pending"}</small>
                                                <h6>{docStep.step}</h6>
                                                {docStep.error_message && <p style={{ color: "#dc3545" }}>{docStep.error_message}</p>}
                                                {!docStep.error_message && docStep.status === "SUCCESS" && <p>Completed successfully</p>}
                                                {docStep.status === "STARTED" && <p>In progress...</p>}
                                                {docStep.status === "SKIPPED" && <p>Skipped</p>}
                                                {docStep.status === "NEEDS_REVIEW" && <p>Requires manual review</p>}
                                             </div>
                                          </div>
                                       </li>
                                    );
                                 })
                              ) : (
                                 <li className="text-center py-3">No document events available</li>
                              )}
                           </ul>
                        </div>
                     </div>
                  </Col>
               </Row>
            </Offcanvas.Body>
         </Offcanvas>
      </>
   );
};

export default DocumentModal;
